<template>
  <div>
    <div v-if="loading || !formLoaded"><span class="spinner"></span></div>
    <b-form
      v-else
      @submit.stop.prevent="onSubmit"
      :class="{ 'p-3 box-shadow2 rounded': !isDarkMode, 'dark-div p-3 box-shadow2 rounded': isDarkMode }"
    >
      <b-form-group label-for="input-company">
        <template v-slot:label>Company <span class="text-danger">*</span></template>
        <b-form-select
          id="input-company"
          v-model="form.company"
          :disabled="isDisableCompanyField"
          :options="companyOptions"
          :state="$v.form.company.$dirty ? !$v.form.company.$error : null"
        />
        <b-form-invalid-feedback>Please select a company.</b-form-invalid-feedback>
      </b-form-group>

      <b-row>
        <b-col md="6">
          <b-form-group label-for="input-block-from">
            <template v-slot:label>Allowed From (day of month) <span class="text-danger">*</span></template>
            <b-form-input id="input-block-from" v-model.number="form.expenseRequestBlockFrom" type="number" min="1" max="31"
              :state="$v.form.expenseRequestBlockFrom.$dirty ? !$v.form.expenseRequestBlockFrom.$error : null" @input="inputFrom" @keydown="restrictDayInput" />
            <b-form-invalid-feedback>Please enter a day from 1 to 31.</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label-for="input-block-to">
            <template v-slot:label>Allowed To (day of month) <span class="text-danger">*</span></template>
            <b-form-input id="input-block-to" v-model.number="form.expenseRequestBlockTo" type="number" min="1" max="31"
              :state="$v.form.expenseRequestBlockTo.$dirty ? !$v.form.expenseRequestBlockTo.$error : null"  @input="inputTo" @keydown="restrictDayInput"/>
            <b-form-invalid-feedback>Please enter a day from 1 to 31 and not before the From day.</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button type="submit" size="sm" :variant="isDarkMode ? 'outline-success' : 'success'" :disabled="loading">
            <span class="spinner spinner-white" v-if="loading"></span>
            <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save
          </b-button>
        </b-col>
        <b-col class="text-right">
          <b-button size="sm" :variant="isDarkMode ? 'outline-warning' : 'warning'" to="/petty-cash/expense-setting">
            <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { required, integer, between } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';

export default {
  name: 'ExpenseRequestBlockFormBox',
  props: { formType: String,isDisableCompanyField:Boolean },
  data() {
    return {
      formLoaded: false,
      companyOptions: [
        { value: null, text: 'Select Company' },
        { value: 'NBL', text: 'NBL' },
        { value: 'SRL', text: 'SRL' }
      ],
      form: { company: null, expenseRequestBlockFrom: null, expenseRequestBlockTo: null }
    };
  },
  validations() {
    return {
      form: {
        company: { required },
        expenseRequestBlockFrom: { required, integer, between: between(1, 31) },
        expenseRequestBlockTo: {
          required,
          integer,
          between: between(1, 31),
          notBeforeFrom: value => Number(value) >= Number(this.form.expenseRequestBlockFrom)
        }
      }
    };
  },
  computed: {
    ...mapState('expenseRequestBlock', ['loading', 'setting']),
    ...mapState('darkMode', ['isDarkMode'])
  },
  mounted() {
    if (this.formType === 'new') this.formLoaded = true;
  },
  watch: {
    setting(value) {
      if (this.formType !== 'update' || !value || !value.id) return;
      this.form = {
        company: value.company,
        expenseRequestBlockFrom: value.expenseRequestBlockFrom,
        expenseRequestBlockTo: value.expenseRequestBlockTo
      };
      this.formLoaded = true;
      this.$v.$reset();
    }
  },
  methods: {
inputFrom(value) {
    if (value === "" || value === null || value === undefined) {
      return;
    }

    const num = Number(value);

    if (num < 1) {
      this.form.expenseRequestBlockFrom = 1;
    } else if (num > 31) {
      this.form.expenseRequestBlockFrom = 31;
    }
  },

  inputTo(value) {
    if (value === "" || value === null || value === undefined) {
      return;
    }

    const num = Number(value);

    if (num < 1) {
      this.form.expenseRequestBlockTo = 1;
    } else if (num > 31) {
      this.form.expenseRequestBlockTo = 31;
    }
  },
  restrictDayInput(event) {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "ArrowLeft",
    "ArrowRight"
  ];

  if (allowedKeys.includes(event.key)) return;

  if (!/^\d$/.test(event.key)) {
    event.preventDefault();
    return;
  }

  const current = event.target.value;
  const nextValue = current + event.key;

  if (Number(nextValue) > 31) {
    event.preventDefault();
  }
},
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.$emit(this.formType === 'new' ? 'add' : 'edit', { setting: { ...this.form } });
    }
  }
};
</script>
